(function($){

	function initAccordion() {
        //Accordion
        $('.accordion').find('.accordion-title').on('click', function(e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $(this).next().slideToggle('fast');
        });
    }
    
       /* Document Ready */
	$(document).ready(function() {
        initAccordion();
	});
    
    // Initialize dynamic block preview (editor).
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=accordion', initAccordion);
    }
})(jQuery);